import {
  faAngleLeft,
  faAngleRight,
  faExpand,
  faHeart,
  faShareNodes,
}
  from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import "./Product_Image.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllWishlist,
  postWishlist,
} from "../../../features/wishlist/wishlistSlice";
import Product_Images_Modal from "../../common_components/common_modal/product_images_modal/Product_Images_Modal";
import { encodeId } from "../../../utils/common";

import { faHeart as regularHeart } from "@fortawesome/free-regular-svg-icons";
const Product_Image = (props) => {
  const images = [
    "/assets/images/product_description/img1.png",
    "d/assets/images/products/vegetables/img2.png",
    "/assets/images/product_description/img1.png",
    "/assets/images/product_description/img1.png",
    "/assets/images/product_description/img1.png",
    "/assets/images/product_description/img1.png",
  ];

  const [isClicked, setIsClicked] = useState(false);

  const toggleHeartColor = () => {
    setIsClicked(!isClicked);
  };



  const [currentImage, setCurrentImage] = useState();
  const [showModal, setShowModal] = useState(false);
  // Default first image

  useEffect(() => {
    setCurrentImage(props?.image?.image);
  }, [props?.image]);

  const [swiperInstance, setSwiperInstance] = useState(null);

  class Zoomable {
    constructor(element, config) {
      this.element = element;
      this.config = this._mergeConfig(config);

      const { initialZoom, minZoom, maxZoom } = this.config;

      this.zoomed = false;
      this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
      this.zoom = this.initialZoom;

      this.img = element.querySelector(".zoomable__img");

      this.img.draggable = false;
      this.element.style.setProperty("--zoom", this.initialZoom);

      this._addEventListeners();
    }

    static get Default() {
      return Default;
    }

    _addEventListeners() {
      this.element.addEventListener("mouseenter", () =>
        this._handleMouseover(),
      );
      this.element.addEventListener("mousemove", (evt) =>
        this._handleMousemove(evt),
      );
      this.element.addEventListener("mouseleave", () => this._handleMouseout());
      this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
    }

    _handleMouseover() {
      if (this.zoomed) {
        return;
      }

      this.element.classList.add("zoomable--zoomed");
      this.zoomed = true;
    }

    _handleMousemove(evt) {
      if (!this.zoomed) {
        return;
      }

      const elPos = this.element.getBoundingClientRect();
      const percentageX = `${((evt.clientX - elPos.left) * 100) /
        elPos.width}%`;
      const percentageY = `${((evt.clientY - elPos.top) * 100) /
        elPos.height}%`;

      this.element.style.setProperty("--zoom-pos-x", percentageX);
      this.element.style.setProperty("--zoom-pos-y", percentageY);
    }

    _handleMouseout() {
      if (!this.zoomed) {
        return;
      }

      this.element.style.setProperty("--zoom", this.initialZoom);
      this.element.classList.remove("zoomable--zoomed");
      this.zoomed = false;
    }

    _handleWheel(evt) {
      if (!this.zoomed) {
        return;
      }

      evt.preventDefault();

      const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
      const { minZoom, maxZoom } = this.config;

      this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
      this.element.style.setProperty("--zoom", this.zoom);
    }

    _mergeConfig(config) {
      return {
        ...this.constructor.Default,
        ...(typeof config === "object" ? config : {}),
      };
    }
  }

  const Default = {
    initialZoom: 3,
    minZoom: 1.25,
    maxZoom: 4,
    zoomSpeed: 0.01,
  };

  const zoomableRef = useRef(null);

  useEffect(() => {
    const element = zoomableRef.current;
    if (!element) return;

    const zoomable = new Zoomable(element);

    return () => {
      element.removeEventListener("mouseenter", zoomable._handleMouseover);
      element.removeEventListener("mousemove", zoomable._handleMousemove);
      element.removeEventListener("mouseleave", zoomable._handleMouseout);
      element.removeEventListener("wheel", zoomable._handleWheel);
    };
  }, []);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const postWishlistData = async (id) => {
    const res = await dispatch(postWishlist(id));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
      // await dispatch(getAllProducts({}));
      // await dispatch(getGroupByProduct({}));
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();
  const [isLogedIn, setIsLogedIn] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    if (user?.id) {
      dispatch(getAllWishlist());
    }
  }, []);

  useEffect(() => {
    if (props?.image?.Product_Images?.length > 0) {
      setCurrentIndex(0);
      setCurrentImage(props.image.Product_Images[0].image);
    }
  }, [props?.image]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const handleMainSliderClick = (direction) => {
    const images = props?.image?.Product_Images;
    if (!images || images.length === 0) return;

    let newIndex = currentIndex;

    if (direction === "next") {
      newIndex = currentIndex + 1;
      if (newIndex >= images.length) {
        newIndex = 0; // loop to first
      }
    } else if (direction === "prev") {
      newIndex = currentIndex - 1;
      if (newIndex < 0) {
        newIndex = images.length - 1; // loop to last
      }
    }

    setCurrentIndex(newIndex);
    setCurrentImage(images[newIndex].image);
  };

  const productUrl = `${window.location.origin}/product-description/${encodeId(
    props?.image?.id,
  )}`;
  const productName = props?.image?.name;
  const handleShare = () => {
    const url = productUrl || window.location.href;
    const title = productName || document.title;

    if (navigator.share) {
      // Native share (mobile + some desktop browsers)
      navigator
        .share({
          title: title,
          text: `Check out this product: ${title}`,
          url: url,
        })
        .catch((err) => console.error("Share cancelled", err));
    } else {
      // Fallback: Open social share links (example: WhatsApp)
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        `Check out this product: ${title} - ${url}`,
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <>
      {/* {props?.image && props?.image?.length > 0 ? ( */}
      <div className="Product_Image">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="img_main_container">
              <div className="product-detail text-center">
                <div className="specs" ref={zoomableRef}>
                  <img
                    src={process.env.REACT_APP_IMG_URL + currentImage}
                    className="zoomable__img"
                    alt="Selected"
                  />
                </div>
              </div>

              <div
                className="zoom_div"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <img src="/assets/images/icons/zoom.png" className="zoom_img" />
                <span className="inner_text">Zoom</span>
              </div>

              <div className="silder_btn">
                <div
                  className="back_btn_holder"
                  onClick={() => handleMainSliderClick("prev")}
                >
                  <div className="back_btn">
                    <p>
                      {" "}
                      <FontAwesomeIcon icon={faAngleLeft} />
                    </p>
                  </div>
                </div>
                <div
                  className="back_btn_holder"
                  onClick={() => handleMainSliderClick("next")}
                >
                  <div className="back_btn">
                    <p>
                      {" "}
                      <FontAwesomeIcon icon={faAngleRight} />
                    </p>
                  </div>
                </div>
              </div>

              <div className="two_icons_holder">
                {/* Share Icon */}
                <div className="icon_holder" onClick={handleShare}>
                  <FontAwesomeIcon icon={faShareNodes} className="share_icon" />
                </div>

                {isSignIn && (
                  <div
                    className="icon_holder"
                    onClick={() => postWishlistData(props.image?.id)}
                  >
                    <FontAwesomeIcon
                      icon={regularHeart}
                      className={`heart_icon ${allWishlist?.data?.some(
                        (item) => item.product_id === props.image?.id,
                      )
                          ? "clicked active"
                          : ""
                        }`}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="main">
              <div className="sidebar-swiper">
                <Swiper
                  slidesPerView={"auto"}
                  modules={[Navigation, Autoplay]}
                  breakpoints={{
                    0: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    380: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    485: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    575: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },

                    768: {
                      slidesPerView: 4,
                      spaceBetween: 10,
                    },
                    992: {
                      slidesPerView: 2.2,
                      spaceBetween: 10,
                    },

                    1200: {
                      slidesPerView: 2.5,
                      spaceBetween: 10,
                    },
                    1440: {
                      slidesPerView: 2.5,
                      spaceBetween: 10,
                    },
                    2000: {
                      slidesPerView: 2.5,
                      spaceBetween: 10,
                    },
                  }}
                  pagination={{ clickable: true }}
                  className="mySwiper category_slider product_image_slider"
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                >
                  {props?.image?.Product_Images?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className={`gallery-imgs ${currentIndex === index ? "active" : ""
                          }`}
                        onClick={() => {
                          setCurrentIndex(index);
                          setCurrentImage(item.image);
                        }}
                      >
                        <img
                          src={process.env.REACT_APP_IMG_URL + item.image}
                          className="inner-img"
                          alt={`Image ${index + 1}`}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
        <div className=""></div>
      </div>

      <Product_Images_Modal
        images={props?.image?.Product_Images}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      {/* <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        loginDone={() => {
          setIsLogedIn(true);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      /> */}
      {/* ) : (
        <></>
      )} */}
    </>
  );
};

export default Product_Image;
